import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Power"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.8749 4.305L16.1249 5.6025C19.3586 7.4695 20.9352 11.2757 19.9688 14.8825C19.0024 18.4892 15.7339 20.9972 11.9999 20.9972C8.26591 20.9972 4.99745 18.4892 4.03102 14.8825C3.06459 11.2757 4.64117 7.4695 7.87491 5.6025L7.12491 4.305C3.30322 6.51146 1.43998 11.0097 2.58213 15.2722C3.72427 19.5348 7.587 22.4987 11.9999 22.4987C16.4128 22.4987 20.2755 19.5348 21.4177 15.2722C22.5598 11.0097 20.6966 6.51146 16.8749 4.305ZM11.25 1.5H12.75V12H11.25V1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Power.vue"]]);
